import React from 'react';
import styled from '@emotion/styled';
import { BodyTextMedium, Grid, GridItem, HeadingText30 } from '@modernhealth/vital-components';
import { breakpointValues, colors } from '@modernhealth/vital-foundation';

import { mediaQueryMinWidth } from '../utils';

const Wrapper = styled.div({
  padding: 32,
  [mediaQueryMinWidth(breakpointValues.lg)]: {
    paddingLeft: 100,
    paddingRight: 100,
  },
});

const MenuHeader = styled(HeadingText30)`
  margin-bottom: 32px;
`;

const MenuText = styled(BodyTextMedium)`
  margin-bottom: 16px;
  color: ${colors.gray65};
`;

const MenuTextLink = styled.a({
  color: colors.gray85,
  '&:hover': {
    color: colors.gray65,
  },
});

const Footer: React.FC = () => {
  return (
    <Wrapper>
      <Grid>
        <GridItem lg={1} md={2} column>
          <BodyTextMedium marginBottom={32}>
            The personalized preventative <br />
            mental health care platform <br /> for enterprises around the world.
          </BodyTextMedium>
        </GridItem>
        <GridItem lg={1} md={2} column>
          <MenuHeader>Modern Health</MenuHeader>
          <TextLink text="How It Works" link="https://www.modernhealth.com/how-it-works" />
          <TextLink text="Providers" link="https://www.modernhealth.com/providers" />
          <TextLink text="Consultants" link="https://www.modernhealth.com/consultants" />
          <TextLink text="Resources" link="https://www.modernhealth.com/resources" />
        </GridItem>
        <GridItem lg={1} md={2} column>
          <MenuHeader>Our Company</MenuHeader>
          <TextLink text="About Us" link="https://www.modernhealth.com/about-us" />
          <TextLink text="Press" link="https://www.modernhealth.com/press-media" />
          <TextLink text="Careers" link="https://www.modernhealth.com/careers" />
          <TextLink text="Blog" link="https://www.modernhealth.com/blog-posts" />
        </GridItem>
        <GridItem lg={1} md={2} column>
          <MenuHeader>Policies and Status</MenuHeader>
          <TextLink text="Disclosure Policy" link="https://www.modernhealth.com/disclosures" />
          <TextLink text="System Status" link="https://status.joinmodernhealth.com/" />
          <TextLink text="Terms of Service" link="https://www.modernhealth.com/terms-of-use" />
          <TextLink text="Privacy Policy" link="https://www.modernhealth.com/privacy-notice" />
        </GridItem>
        <GridItem lg={1} md={2} column>
          <MenuHeader>Contact Us</MenuHeader>
          <a href="mailto:info@modernhealth.com">
            <HeadingText30 fontColor="blue55">info@modernhealth.com</HeadingText30>
          </a>
        </GridItem>
      </Grid>
    </Wrapper>
  );
};

const TextLink = ({ text, link }: { text: string; link: string }) => {
  return (
    <MenuText>
      <MenuTextLink href={link} target="_blank">
        {text}
      </MenuTextLink>
    </MenuText>
  );
};

export default Footer;
